<template>
  <div>
    <!--彈出視窗-->
    <v-dialog
      v-model="visible"
      :persistent="isPersistent"
      :max-width="width">
      <v-card>
        <v-card-title class="headline">
          {{title}}
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <span v-if="isHtmlContent" class="subheading">
            <p v-html="content"></p>
          </span>
          <span v-else class="title">{{content}}</span>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn v-if="showCancel"  class="red" dark text @click="cancelEvent">取消</v-btn>
          <v-btn class="primary" dark text @click="confirmEvent">確定</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  import MobileDetect from 'mobile-detect';
  const md = new MobileDetect(window.navigator.userAgent);
export default {
  name: 'AlertView',
  props: {
    visible: Boolean,
    title: String,
    content: String,
    showCancel: Boolean,
    isHtmlContent:Boolean,
    isPersistent:Boolean
  },
  data() {
    return {
      width: md.phone() ? '80%':'50%',
    }
  },
  methods: {
    confirmEvent() {
      this.$emit('confirmEvent');
    },
    cancelEvent() {
      this.$emit('cancelEvent');
    },
    handler(event) {
      console.log(`handle ${event}`);
    },
  },
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/AlertView.vue